import { ComponentProps } from 'react';
import { ConfirmationModal } from '../../../../../ui/components/pure/modal-content/confirmation-modal.component';

export function makeUndoCancellationActionProps({
  isLoading,
  errorMessage,
  onCancel,
  onConfirm
}: {
  errorMessage?: string;
  isLoading: boolean;
  onCancel(): void;
  onConfirm(): void;
}): ComponentProps<typeof ConfirmationModal> {
  return {
    isLoading,
    content: modalContent,
    title: 'Undo Cancellation?',
    cancelButton: {
      color: 'secondary',
      label: 'No'
    },
    actionButton: {
      color: 'primary',
      label: 'Undo Cancellation'
    },
    errorMessage,
    onCancel,
    onConfirm
  };
}

const modalContent = [
  `Undoing the cancellation will put your order back into a Booked state and allow you to make deliveries for it.`,
  `Are you sure?`
];
